import { action, Action } from 'easy-peasy';

export interface IAiPPTModel {
    animation: boolean;
    setAnimation: Action<IAiPPTModel, boolean>;
    finish: boolean;
    setFinish: Action<IAiPPTModel, boolean>;
}

export const aiPPTModel: IAiPPTModel = {
    animation: false,
    setAnimation: action((state, animation) => {
        state.animation = animation;
    }),
    finish: true,
    setFinish: action((state, finish) => {
        state.finish = finish;
    }),
};
